import { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Box, Button, Popover, Tooltip, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import initials from 'initials'
import ListUserNavigation from './ListUserNavigation'
import useToggleUserPopOver from './useToggleUserPopOver'

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: theme.spacing(3),
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}))

const UserNavigationDesktop = ({ user, navigationItems }) => {
  const { isOpen, handleOpen, handleClose } = useToggleUserPopOver()
  const idUserPopOver = isOpen ? 'user-menu' : undefined
  const popOverRef = useRef()
  const classes = useStyles()
  const { firstName, fullName, role, avatarUri } = user
  const userInitials = useMemo(() => initials(fullName), [fullName])

  return (
    <Box display="flex" alignItems="center" ml={1}>
      <Tooltip title={`Gebruikers menu van ${fullName}`}>
        <Button
          aria-label={`${fullName} (${role})`}
          aria-describedby={idUserPopOver}
          aria-controls={idUserPopOver}
          aria-haspopup="true"
          ref={popOverRef}
          onClick={handleOpen}
          size="small"
          data-analytics="userNavigationDesktopToggle"
          className={classes.button}
        >
          <Box display="flex" alignItems="center">
            <Avatar alt={fullName} src={avatarUri || null} className={classes.avatar}>
              {userInitials}
            </Avatar>
            <Box ml={1} mr={1}>
              <Typography variant="h5" component="span" noWrap>
                {firstName}
              </Typography>
            </Box>
          </Box>
        </Button>
      </Tooltip>
      <Popover
        id={idUserPopOver}
        open={isOpen}
        anchorEl={popOverRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ListUserNavigation user={user} navigationItems={navigationItems} />
      </Popover>
    </Box>
  )
}

UserNavigationDesktop.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    institute: PropTypes.string,
    avatarUri: PropTypes.string,
  }).isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      handleClick: PropTypes.func.isRequired,
      hideXsDown: PropTypes.bool,
    })
  ).isRequired,
}

export default UserNavigationDesktop
